<template>
    <div class="d-flex align-center"
         :class="{ 'flex-wrap justify-center': $vuetify.display.smAndDown}"
    >
        <p class="mr-2">{{$t('eshop::group-sorting.sort')}}: </p>
        <v-select
            :items="itemsSelect"
            item-title="state"
            item-value="value"
            variant="outlined"
            density="compact"
            :model-value="sort"
            hide-details
            @update:modelValue="emit('changeSort', $event)"

        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { trans } from 'laravel-vue-i18n';

defineProps({
    mode: Number,
    sort: {
        type: String,
        default: 'default'
    },
})
const emit = defineEmits(['changeMode', 'changeSort'])
const itemsSelect = computed(() => [
    {state: trans('eshop::group-sorting.default'), value: 'default'},
    {state: trans('eshop::group-sorting.name_desc'), value: 'name_desc'},
    {state: trans('eshop::group-sorting.name_asc'), value: 'name_asc'},
    {state: trans('eshop::group-sorting.price_asc'), value: 'price_asc'},
    {state: trans('eshop::group-sorting.price_desc'), value: 'price_desc'},
]);

</script>

<style scoped lang="scss">


.v-text-field.v-text-field--solo .v-input__control {
    min-height: 10px !important;
}

</style>
